import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loader() {
  return (
    <Box sx={{ display: 'flex', position : 'fixed' , top : '48% !important' , left : '48% !important' }}>
      <CircularProgress />
    </Box>
  );
}